import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { AuthenticationService } from '@core/auth/authentication.service';
import { BaseComponent } from '@core/component/base.component';
import { Beneficiario, Cobertura, Empresa, PropostaVidaIndividual, PropostaVidaGrupo, Segurado, TabHeader, TiposProdutos } from '../models';
import { ToastService } from '../services/toast.service';
import { Router } from '@angular/router';
import { Masks } from '@core/custom-validators/masks';
import { ProposalStatusEnum } from '../enumerators';
import { PropostaService } from '../services/proposta.service';
import { RamosCoberturasService } from '../services/ramos-coberturas.service';
import { TipoPropostaApoliceEnum } from '../enumerators/types';
import { CoberturaResponse } from '../models/ramos-coberturas';
import { TiposProdutoService } from '../services/tipos-produto.service';
import { CnaeService } from '../services/cnae.service';
import { DevModeService } from '@core/services/dev-mode.service';

@Component({
  selector: 'app-cadastrar-proposta',
  templateUrl: './cadastrar-proposta.component.html',
  styleUrls: ['./cadastrar-proposta.component.scss', './../styles.scss']
})
export class CadastrarPropostaComponent extends BaseComponent implements OnInit {

  // Obrigatorio em custom products
  cadastro: { nomeProduto: string, nomeMetodo: string } = {
    nomeProduto: 'RNPA Pessoas',
    nomeMetodo: 'Cadastrar Proposta'
  }

  // Main body de proposta
  proposta: PropostaVidaIndividual | PropostaVidaGrupo = new PropostaVidaIndividual({ coberturas: [new Cobertura({})], beneficiarios: [new Beneficiario({})] })

  // Listagem de coberturas, tipos de produtos e status de proposta
  coberturas: CoberturaResponse[]
  tiposProdutos: TiposProdutos[]
  motivosRecusa: any[]
  proposalStatusOptions = Object.values(ProposalStatusEnum)
  divisoesCnae: any[]

  // Seta os Tabs que trocam o formulario entre VI e VG
  tabHeaders: TabHeader[] = [
    { name: 'Cadastrar proposta de CPF', active: true, type: TipoPropostaApoliceEnum.Vi },
    { name: 'Cadastrar proposta de CNPJ', active: false, type: TipoPropostaApoliceEnum.Vg },
  ]

  // enums para HTML
  proposalStatusEnum = ProposalStatusEnum
  tipoPropostaApolice = TipoPropostaApoliceEnum

  // Masks
  inputMasks = {
    cnpj: {
      mask: Masks.cnpj,
      guide: false,
      modelClean: true
    },
    cpf: {
      mask: Masks.cpf,
      guide: false,
      modelClean: true
    },
    cpfCnpj: {
      mask: Masks.cpfCnpj,
      guide: false,
      modelClean: true
    },
    telefone: {
      mask: Masks.telefone,
      guide: false,
      modelClean: true
    },
    number: {
      mask: Masks.integer,
      guide: false,
      modelClean: true
    },
    decimal: {
      mask: Masks.decimal,
      guide: false,
      modelClean: true
    },
    currency: {
      mask: Masks.currency,
      guide: false,
      modelClean: true
    },
    cnae: {
      mask: Masks.cnae,
      guide: false,
      modelClean: true
    },
    char: {
      mask: Masks.char,
      guide: false,
      modelClean: true
    }
  }

  // Dicionario de Ids
  idDictionary = {
    coberturas: {},
    motivosRecusa: {},
    tiposProduto: {},
    divisoesCnae: {},
  }

  validateInputEvent = new EventEmitter<boolean>()

  @Input() idProduto: number = 89;
  @Input() idMetodo: number = 1937;
  @Input() dsServico: string;
  @Input() dsMetodo: string;
  @Input() disabled: any;
  @Input() consulta: any;

  constructor(
    public _authenticationService: AuthenticationService,
    private _ramosCoberturasService: RamosCoberturasService,
    private _router: Router,
    private _propostaService: PropostaService,
    private _toastService: ToastService,
    private _tiposProdutoService: TiposProdutoService,
    private _cnaeService: CnaeService,
    private _devModeService: DevModeService

  ) {
    super(_authenticationService)
  }

  ngOnInit() {
    this.fillSelectOptions()
    this.handleTabState(this.tabHeaders)
  }

  fillSelectOptions() {
    this._ramosCoberturasService.listCoberturas().subscribe((res: CoberturaResponse[]) => {
      this.coberturas = res.sort((a, b) => {
        return a.cobertura > b.cobertura ? 1 : a.cobertura < b.cobertura ? -1 : 0
      })
      this.idDictionary.coberturas = res.reduce((obj, motivo) => {
        obj[motivo.id] = motivo.cobertura;
        return obj;
      }, {});
    })

    this._tiposProdutoService.listarTiposProduto().subscribe((res: TiposProdutos[]) => {
      this.tiposProdutos = res
    })

    this._propostaService.listarMotivoRecusa().subscribe((res: any[]) => {
      this.motivosRecusa = res
    })

    this._cnaeService.listarDivisoesCnae().subscribe((res: any[]) => {
      this.divisoesCnae = res.sort((a, b) => {
        return parseInt(a.divisaoId) > parseInt(b.divisaoId) ? 1 : parseInt(a.divisaoId) < parseInt(b.divisaoId) ? -1 : 0
      });

      this.idDictionary.divisoesCnae = res.reduce((obj, cnae) => {
        obj[cnae.divisaoId] = cnae.descricao;
        return obj;
      }, {});
    })
  }

  handleTabState(event: TabHeader[]) {
    const eventTypeValue = event.find(i => i.active).type
    this.tabHeaders = event
    if (eventTypeValue == TipoPropostaApoliceEnum.Vi) {
      this.proposta = new PropostaVidaIndividual({ tipoPropostaApolice: eventTypeValue, coberturas: [new Cobertura({})], beneficiarios: [new Beneficiario({})], segurado: new Segurado({}) })
    } else {
      this.proposta = new PropostaVidaGrupo({ tipoPropostaApolice: eventTypeValue, coberturas: [new Cobertura({})], empresa: new Empresa({}) })
    }
  }

  // Adiciona cobertura na proposta
  addCoverage() {
    this.proposta.coberturas.push(new Cobertura({}))
  }

  // Adiciona beneficiario na proposta
  addRecipient() {
    this.proposta['beneficiarios'].push(new Beneficiario({}))
  }

  // Remove cobertura na proposta
  removeCoverage(index: number) {
    this.proposta.coberturas.splice(index, 1)
  }

  // Remove beneficiario na proposta
  removeRecipient(index: number) {
    this.proposta['beneficiarios'].splice(index, 1)
  }

  // Envia cadastro
  submitProposta() {
    this.validateInputEvent.emit(true)
    const tipoProduto = this.tabHeaders.find(i => i.active).type
    this._propostaService.createProposta(this.proposta, tipoProduto).subscribe((res) => {
      this._toastService.showSuccess(`A proposta foi cadastrada com sucesso.`);
      this._router.navigate([('/consulta/6/89/1939/consultaRNPAPessoas/POST%20%2Fv1%2Fpropostas-apolices%2Fpropostas%2Frisco-mercado?favorito=false')])
    },
      (err) => {
        const errorMsg = err.status == 422 ?
          (err.error.mensagem) :
          (err.status == 400 && err.error[0].mensagem.includes("`beneficiarios[0].percentualParticipacao`") ?
            String(err.error[0].mensagem).replace("`beneficiarios[0].percentualParticipacao`", "porcentagem de participação") :
            "Verifique os campos inválidos");

        this._toastService.showError(errorMsg)
      })
  }

  calcTotalSegurado(colaboradores: string, valorSegurado: string) {
    return parseInt(colaboradores) * parseInt(valorSegurado.replace(/\D/g, ''))
  }

  goToLote() {
    this._router.navigate([('lote/cadastrar')])
  }

  goToManual() {
    this._devModeService.enableDevMode(this._authenticationService.currentUser);
    this._router.navigate(['/assets/docs/devportal/rnpa-pessoas/index.html']);
  }
}
